import ZSpinner from './z-spinner-view';

export default ZSpinner;
